export default __webpack_public_path__ + "static/media/1536x600 rabbit looking at viewer.146dcba5.jpg";